<template>
  <div class="multi-img-container" :style="imageWrapStyle">
    <image-box
      v-for="(it, idx) in conf.imgList"
      v-show="showIdx === idx"
      :key="it.imgSrc"
      :ref="`TmMultiImg${idx}`"
      :src="it.imgSrc"
      width="100%"
      height="100%"
      :style="tmMultiImgStyle"
    />
  </div>
</template>

<script>
import ImageBox from '../../tumeng-Image/Image.vue'

export default {
  name: 'TumengMultiImg',
  components: {
    ImageBox
  },
  props: {
    conf: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showIdx: 0,
    }
  },
  computed: {
    imageWrapStyle() {
      return {
      }
    },
    tmMultiImgStyle() {
      return {
        // transform: 'rotate(' + this.conf.rotate + 'deg)',
        overflow: 'hidden',
      }
    }
  },
  mounted() {
    const showImg = () => {
      setTimeout(() => {
        this.showIdx += 1
        if (this.showIdx >= this.conf.imgList.length) {
          this.showIdx = 0
        }
        showImg()
      }, this.conf.imgList[this.showIdx].duration * 1000)
    }
    showImg()
  }
}
</script>

<style lang="scss" scoped>
.multi-img-container {
  width: 100%;
  height: 100%;
  > img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
